import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=d6945378&"
import script from "./Settings.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Settings.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports